{
  "name": "@nurliman/file-exists-cli",
  "description": "Check if a file exists",
  "version": "1.0.2",
  "type": "module",
  "main": "dist/index.js",
  "bin": {
    "exists": "./dist/index.js"
  },
  "publishConfig": {
    "access": "public"
  },
  "license": "MIT",
  "author": {
    "name": "Nurliman Diara",
    "email": "nurlimandiara@gmail.com",
    "url": "https://nurliman.dev"
  },
  "repository": {
    "type": "git",
    "url": "https://github.com/nurliman/file-exists-cli.git"
  },
  "keywords": [
    "stdlib",
    "stdfs",
    "fs",
    "exists",
    "existssync",
    "polyfill",
    "path",
    "existence",
    "check",
    "async",
    "sync",
    "file",
    "filesystem"
  ],
  "files": ["dist/", "*.md", "package.json"],
  "scripts": {
    "build": "tsup",
    "prebuild": "npm run check && npm run lint:fix",
    "check": "tsc --noEmit",
    "lint": "biome check .",
    "lint:fix": "biome check . --write",
    "lint-staged": "lint-staged",
    "changeset": "changeset",
    "version-packages": "changeset version",
    "release": "npm run build && changeset publish",
    "prepare": "lefthook install"
  },
  "packageManager": "bun@1.1.38",
  "dependencies": {
    "execa": "^9.5.2",
    "meow": "^13.2.0"
  },
  "devDependencies": {
    "@biomejs/biome": "^1.9.4",
    "@changesets/changelog-github": "^0.5.0",
    "@changesets/cli": "^2.27.10",
    "@tsconfig/recommended": "^1.0.8",
    "@types/bun": "latest",
    "@types/node": "^22",
    "lefthook": "^1.9.2",
    "lint-staged": "^15.2.11",
    "tsup": "^8.3.5",
    "typescript": "^5.7.2"
  },
  "lint-staged": {
    "**/*.+(js|mjs|cjs|jsx|ts|cts|mts|tsx)": "biome check --write --no-errors-on-unmatched"
  },
  "trustedDependencies": ["@biomejs/biome", "esbuild", "lefthook"]
}
